<template>
    <div class="rzy-page">

        <div class="rzy-top-bar">
            <el-button type="primary" @click="Add()" style="" icon="el-icon-circle-plus">新增</el-button>
            <!-- <el-button type="primary" @click="XXXXXX()" style="" icon="el-icon-edit">修改</el-button> -->
            <el-button type="primary" @click="startDialogOpend" style="" icon="el-icon-video-play">启用</el-button>
            <el-button type="primary" @click="stopDialogOpend" style="" icon="el-icon-video-pause">停用</el-button>
            <el-button type="primary" @click="delDialogOpend" style="" icon="el-icon-remove">删除</el-button>

            <el-button type="primary" @click="XXXXXX()" style="" icon="el-icon-refresh">刷新</el-button>
            <el-button type="primary" @click="initPrint('localListTableId')" icon="el-icon-printer">打印</el-button>
            <!--            
            <el-date-picker @change="daterangeSelectChange()" v-model="daterangeSelectResult" type="daterange"
                align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                :picker-options="pickerOptions">
            </el-date-picker> 
            -->
        </div>

        <el-table :data="responseData" :header-cell-style="{'text-align':'center'}" :cell-style="{'padding':'0px'}"
            border stripe id="localListTableId" @selection-change="handleSelectionChange">

            <!-- 选择多行数据时使用 Checkbox。 -->
            <el-table-column type="selection" width="40" align="center">
            </el-table-column>

            <el-table-column sortable prop="local_id" label="行" width="40" align="center">
            </el-table-column>
            <el-table-column sortable prop="status_change" label="状态" align="center">
            </el-table-column>
            <el-table-column sortable prop="number" label="编号" align="center">
                <template slot-scope="scope">
                    <el-link type="primary" @click="goToDetails(scope.row.id)">
                        {{ scope.row.number }}
                    </el-link>
                </template>
            </el-table-column>
            <el-table-column sortable prop="name" label="名称" align="center">
            </el-table-column>
            <el-table-column sortable prop="enableNegative_change" label="允许负库存" align="center">
            </el-table-column>
            <el-table-column sortable prop="enablePosition_change" label="启用仓位" align="center">
            </el-table-column>
            <el-table-column sortable prop="contact" label="仓管员" align="center">
            </el-table-column>
            <el-table-column sortable prop="phone" label="手机" align="center">
            </el-table-column>
            <el-table-column sortable prop="address" label="地址" align="center">
            </el-table-column>
            <el-table-column sortable prop="remarks" label="备注" align="center">
            </el-table-column>
        </el-table>

        <el-pagination style="text-align: center" background layout="prev, pager, next"
            @current-change="handleCurrentChange" :page-size="pageInfo.size" :current-page="pageInfo.page"
            :page-count="totalPages">
        </el-pagination>

        <!-- 启用 对话框 -->
        <el-dialog title="启用仓库" :visible.sync="startDialogVisible" width="50%" @close="startDialogClosed">
            <el-form ref="startFormRef" label-width="90px" :model="startForm">
                <el-form-item label="确定启用?">
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="startDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="startWarehouse">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 停用 对话框 -->
        <el-dialog title="停用仓库" :visible.sync="stopDialogVisible" width="50%" @close="stopDialogClosed">
            <el-form ref="stopFormRef" label-width="90px" :model="stopForm">
                <el-form-item label="确定停用?">
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="stopDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="stopWarehouse">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 删除 对话框 -->
        <!-- <del-confirm ref="delConfirm" @update="getList(pageInfo.page)" /> -->
        <el-dialog title="删除仓库" :visible.sync="delDialogVisible" width="50%" @close="delDialogClosed">
            <el-form ref="delFormRef" label-width="90px" :model="delForm">
                <el-form-item label="确定删除?">
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="delDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="delWarehouse">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    // import { DelConfirm } from './components'
    export default {
        components: {
            // DelConfirm,
        },
        data() {
            return {
                //分页 -- sta
                pageInfo: {
                    page: 1,
                    size: 15,
                },
                totalPages: 0,
                //分页 -- end


                //日期范围选择控件 -- sta
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);

                        }
                    }]
                },
                daterangeSelectResult: '', //日期范围 选择的结果
                //日期范围选择控件 -- end

                responseData: [],
                multipleSelection: [], //列表选中多行。
                m_ids: '', //POST 参数

                startDialogVisible: false, //启用 对话框
                stopDialogVisible: false, //停用 对话框
                delDialogVisible: false, //删除 对话框
            }
        },
        methods: {
            // 在打印当前报表前，拼接title
            initPrint(id) {
                this.utils.printTable(id, `入库单列表`)
            },

            // 分页切换
            handleCurrentChange(newNum) {
                this.getPeiBuList(newNum)
            },

            // 日期范围选择控件，内容改变事件
            daterangeSelectChange() {
                // console.log('daterangeSelectResult=', this.daterangeSelectResult)
                // console.log('daterangeSelectResult[0]=', this.daterangeSelectResult[0])
                // console.log('daterangeSelectResult[1]=', this.daterangeSelectResult[1])

                //开始时间 转 时间戳
                let m_date = new Date(this.daterangeSelectResult[0]);
                let m_time = Date.parse(m_date); //精确到秒,毫秒会用000替代
                this.pageInfo.startTime = m_time
                // console.log('startTime=', this.pageInfo.startTime)

                //结束时间 转 时间戳
                m_date = new Date(this.daterangeSelectResult[1]);
                m_time = Date.parse(m_date); //精确到秒,毫秒会用000替代
                this.pageInfo.endTime = m_time
                // console.log('endTime=', this.pageInfo.endTime)

                this.refreshPage()
            },

            // 刷新
            refreshPage() {
                this.getList(1)
                this.$Message.success('刷新成功')
            },

            //列表中 选中多行。
            handleSelectionChange(val) {
                console.log("val=", val)
                this.multipleSelection = val
            },

            // 条件查询
            queryBySelect(pageInfo) {
                this.pageInfo = pageInfo
                this.getList(1)
            },
            // 清空条件查询
            clearQuery(pageInfo) {
                this.pageInfo = pageInfo
                this.getList(1)
            },

            // 获取XX分页列表
            getList(val) {
                this.pageInfo.page = val
                this.$requestBase({
                    url: 'v1/warehouse/list',
                    method: 'get',
                    params: this.pageInfo
                }).then(res => {
                    this.responseData = this.formatResponse(res.data.list)
                    this.totalPages = res.data.pages
                })
            },
            // 格式化XX列表
            formatResponse(response) {
                response.forEach((item, index) => {
                    item.local_id = index + 1

                    if (item.enableNegative) {
                        item.enableNegative_change = '是'
                    } else {
                        item.enableNegative_change = '否'
                    }
                    if (item.enablePosition) {
                        item.enablePosition_change = '是'
                    } else {
                        item.enablePosition_change = '否'
                    }

                    switch (item.status) {
                        case 0:
                            item.status_change = '停用'
                            break;
                        case 1:
                            item.status_change = '启用'
                            break;
                        default:
                            break;
                    }
                })
                return response
            },

            //新增
            Add() {
                this.$router.push({
                    path: `warehouseConstructionAdd`,
                    query: {
                        type: 0, //0=新建, 1=编辑.
                        // wuLiaoId: XXX, 不需要
                    }
                })
            },
            // 路由至胚布详情
            goToDetails(id) {
                this.$router.push(`warehouseConstructionDetalis/${id}`)
            },

//启用 ---------------------------------sta
            // 显示 启用对话框
            startDialogOpend() {
                if(0 === this.multipleSelection.length){
                    this.$Message.success('请使用勾选框选择')
                }else{
                this.startDialogVisible = true
                }
            },
            // 监听 启用对话框 的关闭事件
            startDialogClosed() {
                this.$refs.startFormRef.resetFields()
            },
            //启用 仓库
            startWarehouse() {
                this.m_ids = '' //初始化
                for (let i = 0; i < this.multipleSelection.length; i++) {
                    if ('' === this.m_ids) { //第一个直接赋值
                        this.m_ids = this.multipleSelection[i].id
                        console.log('this.m_ids=',this.m_ids)
                    } else {
                        this.m_ids = this.m_ids + ',' + this.multipleSelection[i].id
                        console.log('this.m_ids=',this.m_ids)
                    }
                }

                this.$requestBase({
                    url: 'v1/warehouse/enable',
                    method: 'POST',
                    data: {
                        ids: this.m_ids,
                        enable: 1, //0=停用? 1=启用?
                    },
                }).then(res => {
                    this.getList(1)
                    this.$Message.success('启用成功')
                    
                    this.startDialogVisible = false //关闭对话框
                })
            },
//启用 ---------------------------------end

//停用 ---------------------------------sta
            // 显示 停用对话框
            stopDialogOpend() {
                if(0 === this.multipleSelection.length){
                    this.$Message.success('请使用勾选框选择')
                }else{
                this.stopDialogVisible = true
                }
            },
            // 监听 停用对话框 的关闭事件
            stopDialogClosed() {
                this.$refs.stopFormRef.resetFields()
            },
            //停用 仓库
            stopWarehouse() {
                this.m_ids = '' //初始化
                for (let i = 0; i < this.multipleSelection.length; i++) {
                    if ('' === this.m_ids) { //第一个直接赋值
                        this.m_ids = this.multipleSelection[i].id
                        console.log('this.m_ids=',this.m_ids)
                    } else {
                        this.m_ids = this.m_ids + ',' + this.multipleSelection[i].id
                        console.log('this.m_ids=',this.m_ids)
                    }
                }

                this.$requestBase({
                    url: 'v1/warehouse/enable',
                    method: 'POST',
                    data: {
                        ids: this.m_ids,
                        enable: 0, //0=停用? 1=启用?
                    },
                }).then(res => {
                    this.getList(1)
                    this.$Message.success('停用成功')
                    
                    this.stopDialogVisible = false //关闭对话框
                })
            },
//删除 ---------------------------------end

//删除 ---------------------------------sta
            // 显示 删除对话框
            delDialogOpend() {
                if(0 === this.multipleSelection.length){
                    this.$Message.success('请使用勾选框选择')
                }else{
                this.delDialogVisible = true
                }
            },
            // 监听 删除对话框 的关闭事件
            delDialogClosed() {
                this.$refs.delFormRef.resetFields()
            },
            //删除 仓库
            delWarehouse() {
                this.m_ids = '' //初始化
                for (let i = 0; i < this.multipleSelection.length; i++) {
                    if ('' === this.m_ids) { //第一个直接赋值
                        this.m_ids = this.multipleSelection[i].id
                        console.log('this.m_ids=',this.m_ids)
                    } else {
                        this.m_ids = this.m_ids + ',' + this.multipleSelection[i].id
                        console.log('this.m_ids=',this.m_ids)
                    }
                }

                this.$requestBase({
                    url: 'v1/warehouse/delete',
                    method: 'POST',
                    data: {
                        ids: this.m_ids,
                    },
                }).then(res => {
                    this.getList(1)
                    this.$Message.success('删除成功')
                    
                    this.delDialogVisible = true
                })
            },
//删除 ---------------------------------end
        },
        mounted() {
            this.getList(1)
        },
        activated() {
            this.getList(1)
        }
    }
</script>

<style scoped lang="scss">

</style>
